MOVE.UserProfileLeadInputs = (function (MOVE) {

  var setLeadInputs = function() {
    if ($.cookie('REMEMBER_ME') && !MOVE.DataStore.getData(MOVE.CONSTANTS.CACHED_USER_PROFILE_LEAD_INPUTS)) {
      var account_host = (window.location.hostname.includes('sandbox-qa')) ? 'myaccount-qa' : 'myaccount';
      $.ajax({
        url: 'https://' + account_host + '.realtor.com/my_profile/index.json',
        headers: {"REMEMBER_ME": $.cookie('REMEMBER_ME')},
        success: function (data) {
          let inputs = {};
          inputs['fullName'] = [data.nsi_profile.first_name, data.nsi_profile.last_name].join(" ").trim();
          inputs['email'] = data.nsi_profile.email_address;
          inputs['phone'] = data.nsi_profile.phone;
          MOVE.DataStore.setData(MOVE.CONSTANTS.CACHED_USER_PROFILE_LEAD_INPUTS, JSON.stringify(inputs));
        }
      });
    }
  };

  MOVE.UserProfileLeadInputs =
  {
    setLeadInputs: setLeadInputs
  };
  return MOVE.UserProfileLeadInputs;

})(MOVE || {});



// WEBPACK FOOTER //
// ./shared_critical/user_profile_lead_inputs.js